import { render, staticRenderFns } from "./StatsKpiColumnLabel.vue?vue&type=template&id=1f84b5de&scoped=true&"
import script from "./StatsKpiColumnLabel.vue?vue&type=script&lang=js&"
export * from "./StatsKpiColumnLabel.vue?vue&type=script&lang=js&"
import style0 from "./StatsKpiColumnLabel.vue?vue&type=style&index=0&id=1f84b5de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f84b5de",
  null
  
)

export default component.exports